import { alpha } from "@mui/material/styles";

// Mesma receita das tags dos acessos: fundo translucido, texto e borda na cor da propria tag
const styles = (theme, cor) => ({
	chip: {
		height: 22,
		fontWeight: 500,
		bgcolor: cor ? alpha(cor, 0.2) : theme.palette.action.selected,
		color: cor || theme.palette.text.primary,
		border: `1px solid ${cor || theme.palette.divider}`,
	},
	// Versao mais estreita para caber dentro de seletores
	chipCompacto: {
		height: 18,
		fontSize: "0.7rem",
		"& .MuiChip-label": { px: 0.75 },
	},
});

export default styles;
